var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: { title: _vm.title, visible: "", width: "55%" },
      on: { close: _vm.onCancel },
    },
    [
      _c(
        "el-form",
        { ref: "form", attrs: { model: _vm.form, "label-width": "120px" } },
        [
          _vm.changeType == 0
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("TABLE_HEADER_EXCHANGE_STATUS") } },
                [
                  _c(
                    "el-select",
                    {
                      model: {
                        value: _vm.form.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "status", $$v)
                        },
                        expression: "form.status",
                      },
                    },
                    _vm._l(_vm.statusOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.changeType == 1
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("TABLE_HEADER_DUEDAY") } },
                [
                  _c("el-date-picker", {
                    attrs: { "value-format": "yyyy-MM-dd", type: "date" },
                    model: {
                      value: _vm.form.dueDay,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "dueDay", $$v)
                      },
                      expression: "form.dueDay",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.changeType == 2
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("TABLE_HEADER_KPUSER") } },
                [
                  _c(
                    "el-select",
                    {
                      model: {
                        value: _vm.form.chargeUser,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "chargeUser", $$v)
                        },
                        expression: "form.chargeUser",
                      },
                    },
                    _vm._l(_vm.kpmgUserList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.userName, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { staticClass: "cancel-btn", on: { click: _vm.onCancel } },
            [_vm._v(_vm._s(_vm.$t("btn_cancel")))]
          ),
          _c(
            "el-button",
            {
              staticClass: "wl-green",
              attrs: { type: "primary", loading: _vm.batchChangeLoading },
              on: { click: _vm.onConfirm },
            },
            [_vm._v(_vm._s(_vm.$t("btn_save")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }